import {
	UserSettingsPageContent,
	UserSettingsPageHeader
} from "pages/Preferences/UserSettings/UserSettingsPage.styles.ts";
import InfoBanner from "components/Common/InfoBanner/InfoBanner.tsx";
import CommunicationSettings from "components/Preferences/UserSettings/CommunicationSettings.tsx";
import { useGetPreferencesQuery } from "features/api/preferencesApi.ts";
import { useGetPermissionsQuery } from "features/api/permissionsApi.ts";
import UserPermissionsInfo from "components/Preferences/UserSettings/UserPermissionsInfo.tsx";
import UserSettingsSkeleton from "components/Preferences/UserSettings/UserSettingsSkeleton.tsx";
import { AdminAccessText, AdministratorAccessOnly, UserSettingsHeaderText } from "components/Preferences/text.ts";

const UserSettingsPage = () => {
	const { data: userPreferences, isLoading: isPreferencesLoading } = useGetPreferencesQuery();
	const { data: userPermissions, isLoading: isPermissionsLoading } = useGetPermissionsQuery();

	return (
		<div>
			<UserSettingsPageHeader>
				<h1>{UserSettingsHeaderText}</h1>
			</UserSettingsPageHeader>
			<UserSettingsPageContent>
				{isPermissionsLoading || isPreferencesLoading ? (
					<UserSettingsSkeleton />
				) : (
					<>
						<CommunicationSettings
							userPreferences={userPreferences}
							userPermissions={userPermissions}
						/>
						<InfoBanner
							title={AdministratorAccessOnly}
							bodyText={AdminAccessText}
						/>
						<UserPermissionsInfo userPermissions={userPermissions} />
					</>
				)}
			</UserSettingsPageContent>
		</div>
	);
};

export default UserSettingsPage;
